module.exports = __webpack_public_path__ + "images/ExternalPromo/wix-side-404.png?9e5b0";